import { NgModule} from "@angular/core";
import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { CommonModule} from "@angular/common";

@NgModule({
  declarations: [
    InfiniteScrollDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    InfiniteScrollDirective
  ]
})
export class InfiniteScrollModule {}
